import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Sublocation extends Base {
  /**
   * @description List Sublocation API function
   * @param {?string} filterParams.location Location ID associated with the sublocation
   * @returns {Promise<Response>}
   * @param uid
   */
  list(uid) {
    const url = new URL(this._getFullURL(`/sublocation/bylocation/${uid}`));
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Create sublocation API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload, fileInput, floorplan) {
    const url = this._getFullURL("/sublocation");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput); //logo image
    formdata.append("floorplan", floorplan); //floorplan image

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get sublocation API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/sublocation/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update sublocation API function
   * @param {string} id
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  update = (id, payload, fileInput, floorplan) => {
    const url = this._getFullURL(`/sublocation/${id}`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput); //logo
    formdata.append("floorplan", floorplan); //floorplan image

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });
    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  /**
   * @description Delete sublocation API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  delete = (id) => {
    const url = this._getFullURL(`/sublocation/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      }),
    );
  };
}
